import tokenData from '../../design-tokens/base-tokens.json';
export const MuiStepper = {
    defaultProps: {
        component: 'ol'
    },
    styleOverrides: {
        root: ({ theme }) => ({
            '&.MuiStepper-horizontal': {
                overflow: 'hidden'
            },
            '&:is(ol).MuiStepper-horizontal': {
                marginTop: 0,
                paddingLeft: 0
            },
            '&:not(.MuiStepper-vertical)': {
                display: 'inline-flex',
                alignItems: 'stretch',
                maxWidth: '100%',
                borderRadius: 48,
                border: `1px solid ${tokenData.tokens.palette.grey.grey300}`
            },
            '& [class*=MuiStepLabel-labelContainer]': {
                lineHeight: 1,
                overflow: 'hidden',
                zIndex: 2
            },
            '& .MuiTypography-caption': {
                display: 'block',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                textAlign: 'left'
            },
            '& .MuiStepButton-horizontal': {
                paddingLeft: 4
            },
            '& .MuiStep-root': {
                overflow: 'hidden',
                minWidth: 0,
                padding: 0,
                '&.MuiStepButton-horizontal': {
                    background: tokenData.tokens.palette.background.white,
                    paddingLeft: 0
                },
                '& .MuiStepLabel-horizontal': {
                    marginLeft: 0,
                    paddingRight: 8,
                    padding: 8,
                    overflow: 'hidden',
                    '&:first-of-type': {
                        paddingLeft: 12
                    }
                },
                '& .MuiStepLabel-label': {
                    width: '100%',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                },
                '&. MuiStepLabel-labelContainer': {
                    display: 'flex',
                    overflow: 'hidden'
                },
                '&.MuiStepLabel-labelContainer': {
                    display: 'flex',
                    overflow: 'hidden'
                },
                '&:first-of-type': {
                    '& .MuiStepLabel-root': {
                        marginLeft: 0
                    }
                },
                '& .MuiStep-root': {
                    '&.Mui-completed': {
                        '& .MuiStepLabel-label': {
                            color: tokenData.tokens.palette.green.green700,
                            fontWeight: 600
                        }
                    }
                }
            },
            '&. MuiStepLabel-labelContainer': {
                display: 'flex',
                overflow: 'hidden'
            },
            '&.MuiStepLabel-labelContainer': {
                display: 'flex',
                overflow: 'hidden'
            },
            '& .MuiSvgIcon-root': {
                '&.MuiStepIcon-root': {
                    fontSize: 20,
                    color: tokenData.tokens.palette.grey.disabled,
                    '&.Mui-completed': {
                        color: theme.palette.success.light
                    },
                    '&.Mui-active': {
                        color: theme.palette.primary.main
                    }
                }
            },
            '& .MuiStepLabel-label': {
                ...theme.typography.body1,
                '&.Mui-active': {
                    fontWeight: 600,
                    color: tokenData.tokens.palette.blue.blue700
                },
                '&.Mui-completed': {
                    fontWeight: 600,
                    color: tokenData.tokens.palette.green.green700
                }
            },
            '& .MuiStepIcon-text': {
                fontSize: 12,
                fontWeight: 700
            },
            '& .MuiStepConnector-arrow': {
                marginRight: 16,
                position: 'relative',
                '& > div': {
                    lineHeight: 0,
                    '& > div': {
                        lineHeight: 0
                    }
                }
            },
            '& .MuiStep-horizontal': {
                display: 'flex',
                position: 'relative',
                '& .MuiStepLabel-horizontal': {
                    zIndex: 2
                },
                '&:first-of-type': {
                    '& .MuiStepButton-root': {
                        borderTopLeftRadius: '1.5rem',
                        borderBottomLeftRadius: '1.5rem'
                    }
                },
                '&:last-of-type': {
                    '& .MuiStepButton-root': {
                        borderTopRightRadius: '1.5rem',
                        borderBottomRightRadius: '1.5rem'
                    }
                },
                '&:not(:first-of-type)': {
                    marginLeft: '-28px',
                    '& .MuiStepButton-horizontal': {
                        paddingLeft: 28
                    }
                },
                '& .MuiStep-horizontal': {
                    '& .MuiStepButton-horizontal': {
                        '& .MuiStepLabel-label': {
                            paddingRight: 16
                        }
                    }
                },
                '&:not(:last-of-type)': {
                    '& .MuiStepButton-horizontal': {
                        '&:after': {
                            content: '""',
                            pointerEvents: 'none',
                            display: 'block',
                            position: 'absolute',
                            top: '50%',
                            right: 9,
                            width: 42,
                            height: 42,
                            background: tokenData.tokens.palette.background.white,
                            borderWidth: '1px 1px 0 0',
                            borderStyle: 'solid',
                            borderColor: tokenData.tokens.palette.grey.grey300,
                            transform: 'translateY(-50%) translateX(0) rotate(-45deg)',
                            clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)',
                            zIndex: 1,
                            border: `1px solid ${tokenData.tokens.palette.grey.grey300}`
                        },
                        '&.Mui-disabled': {
                            '&:after': {
                                background: 'transparent'
                            }
                        }
                    }
                }
            }
        })
    }
};
export const MuiMobileStepper = {
    styleOverrides: {
        root: {
            '&.OclcMobileStepper-lines': {
                '& .MuiMobileStepper-dot': {
                    width: 100,
                    borderRadius: 4
                }
            },
            '& .MuiMobileStepper-dot': {
                background: tokenData.tokens.palette.grey.grey300,
                margin: '0 4px'
            },
            '& .MuiMobileStepper-dots': {
                margin: '0 8px'
            },
            '& .MuiMobileStepper-dotActive': {
                background: tokenData.tokens.palette.blue.blue500
            }
        }
    }
};
export const MuiStep = {
    defaultProps: {
        component: 'li'
    },
    styleOverrides: {
        root: {}
    }
};
export const MuiStepButton = {
    styleOverrides: {
        root: ({ theme }) => ({
            [theme.breakpoints.down('sm')]: {
                '&.MuiStepButton-horizontal': {
                    '& [class*=MuiStepLabel-labelContainer]': {
                        display: 'none'
                    }
                },
                '& .MuiStepLabel-iconContainer': {
                    paddingRight: 0
                }
            },
            '& .MuiTouchRipple-root': {
                zIndex: 2
            },
            '&. MuiStepLabel-labelContainer': {
                display: 'flex',
                overflow: 'hidden'
            },
            '&.MuiStepButton-root': {
                margin: 0,
                padding: 0,
                minWidth: 0,
                lineHeight: '1.25',
                '&.Mui-disabled': {
                    background: tokenData.tokens.palette.background.linen
                }
            },
            '&.MuiStepButton-horizontal': {
                paddingRight: 20,
                '&.Mui-focusVisible': {
                    '& .MuiStepLabel-horizontal': {
                        outline: `2px solid ${tokenData.tokens.palette.text.text300}`,
                        outlineOffset: '-4px'
                    }
                }
            },
            '& .MuiStepLabel-root': {
                overflow: 'hidden',
                paddingRight: 16,
                marginLeft: 16
            },
            '& .MuiStepLabel-labelContainer': {
                display: 'flex',
                overflow: 'hidden'
            }
        })
    }
};
